import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { FiLogOut, FiSettings, FiMenu, FiChevronLeft, FiChevronRight } from "react-icons/fi";
import { SidebarData } from "./navdata";
import "./navbarStyle.css";
import { useDispatch, useSelector } from "react-redux";
import { logout, RootState } from "../../stores/store";
import logo from '../../assets/logo-no-bg.png';

function Navbar() {
  const [collapsed, setCollapsed] = useState(true); // by default, the sidebar is collapsed
  const [mobileOpen, setMobileOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const user = useSelector((state: RootState) => state.auth.user);
  
  const dispatch = useDispatch();
  const handleLogout = () => {
    dispatch(logout());
    navigate('/login');
  };
  const handleSettings = () => {
    navigate('/settings');
  };
  const toggleCollapse = () => setCollapsed(!collapsed);
  const toggleMobile = () => setMobileOpen(!mobileOpen);

  return (
    <>
      {/* Mobile Header - Only on mobile */}
      <div className="mobile-header">
        <button className="mobile-menu-btn" onClick={toggleMobile}>
          <FiMenu size={20} />
        </button>
        <div className="mobile-brand">
          <img className="logo-icon" src={logo} alt="Arqite" />
          <span>ARQITE</span>
        </div>
      </div>

      {/* Mobile Overlay */}
      {mobileOpen && <div className="mobile-overlay" onClick={toggleMobile}></div>}

      {/* Constant Sidebar */}
      <div className={`arqite-sidebar ${collapsed ? 'collapsed' : ''} ${mobileOpen ? 'mobile-open' : ''}`}>
        {/* Sidebar Header */}
        <div className="sidebar-header">
          <div className="sidebar-brand">
              <img className="logo-icon" src={logo} alt="Arqite" />
            {!collapsed && <span className="brand-text">ARQITE</span>}
          </div>
          
          {/* Desktop collapse toggle */}
          <button className="collapse-toggle desktop-only" onClick={toggleCollapse}>
            {collapsed ? <FiChevronRight size={20} /> : <FiChevronLeft size={20} />}
          </button>
        </div>

        {/* User Profile */}
        <div className="user-profile">
          <div className="user-avatar">
            <span>{user?.charAt(0)?.toUpperCase()}</span>
          </div>
          {!collapsed && (
            <div className="user-details">
              <div className="user-name">{user}</div>
              <div className="user-status">
                <div className="status-indicator"></div>
                Online
              </div>
            </div>
          )}
        </div>

        {/* Navigation */}
        <nav className="sidebar-nav">
          {SidebarData.map((item, index) => {
            const isActive = location.pathname === item.path;
            return (
              <Link
                key={index}
                to={item.path}
                className={`nav-link ${isActive ? 'active' : ''}`}
                onClick={() => { setMobileOpen(false); setCollapsed(true); }}
                title={collapsed ? item.title : ''}
              >
                <span className="nav-icon">{item.icon}</span>
                {!collapsed && <span className="nav-text">{item.title}</span>}
              </Link>
            );
          })}
        </nav>

        {/* Sidebar Footer */}
        <div className="sidebar-footer">
          <button className="footer-action" onClick={handleSettings} title={collapsed ? 'Settings' : ''}>
            <FiSettings size={18} />
            {!collapsed && <span>Settings</span>}
          </button>
          <button className="footer-action logout" onClick={handleLogout} title={collapsed ? 'Sign Out' : ''}>
            <FiLogOut size={18} />
            {!collapsed && <span>Sign Out</span>}
          </button>
        </div>
      </div>
    </>
  );
}

export default Navbar;
